<template>
    <div class="banner" :style="{'backgroundImage':'url('+bannerBg+')'}">
        <div class="banner-title">{{getBannerTitle}}</div>
        <div class="detail-rule">
          <OldCusterRule></OldCusterRule>
        </div>
    </div>
</template>

<script>
import OldCusterRule from './oldCusterRule.vue'

import BRFOODBANNERBG from '@/assets/images/oldCustomer/99food_banner_bg.png'
import DIDIFOODBANNERBG from '@/assets/images/oldCustomer/didifood_banner_bg.png'
Object.freeze(BRFOODBANNERBG)
Object.freeze(DIDIFOODBANNERBG)

export default {
  name: 'OldCustomreBanner',
  components: {
    OldCusterRule
  },
  data () {
    return {
    }
  },
  props: {
    // banner背景图
    bannerSrc: {
      default: () => {
        return {
          didi: DIDIFOODBANNERBG,
          other: BRFOODBANNERBG
        }
      }
    },
    // 国家
    country: {
      default: 'BR'
    },
    bannerTitle: {
      default: ''
    }
  },
  computed: {
    getBannerTitle () {
      return this.bannerTitle || this.$t('FoodC_C_Mission_Centre_HafM')
    },
    bannerBg () {
      return this.country === 'BR' ? this.bannerSrc.other : this.bannerSrc.didi
    }
  }
}
</script>
<style lang="stylus" scoped>
.banner
    height 536px
    background-size 100% 536px
    overflow hidden
    position relative
    .banner-title
        height 68px
        font-family 'Aspira Demi'
        font-size 56px
        color #FFFFFF
        line-height 68px
        font-weight 500
        position absolute
        left 42px
        top 260px
    .detail-rule
        position absolute
        left 40px
        top 367px
</style>